const UTM_KEY = "bespoke_utm";

const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid", "msclkid"];

/**
 * Capture UTM and ad-click params from the URL on first landing.
 * Stores them in sessionStorage so they persist across SPA navigations
 * but reset on new sessions (new tab / window).
 * Call this once on app boot (e.g. in App.js or index.js).
 */
export function captureUtmParams() {
  try {
    // Don't overwrite if already captured this session
    if (sessionStorage.getItem(UTM_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    let found = false;
    UTM_PARAMS.forEach((key) => {
      const val = params.get(key);
      if (val) {
        utm[key] = val;
        found = true;
      }
    });
    if (found) {
      sessionStorage.setItem(UTM_KEY, JSON.stringify(utm));
    }
  } catch {
    // sessionStorage blocked — silently ignore
  }
}

/**
 * Get captured UTM params (or empty object if none).
 */
export function getUtmParams() {
  try {
    const raw = sessionStorage.getItem(UTM_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
